import {ICompetition} from '@components/competitions/ICompetitions';
import {createContext, useContext} from 'react';

type AnswerMap = {
	[day: number]: {
		[question: number]: number | null;
	};
};

type ContextType = {
	competition: ICompetition;
	mission: number;
	setMission: (_value: number) => void;
	phone: string;
	setPhone: (_value: string) => void;
	day: number;
	setDay: (_value: number) => void;
	answers: AnswerMap;
	setAnswers: (_value: AnswerMap) => void;
};

const CompetitionMuharramContext = createContext<ContextType>({
	competition: {} as ICompetition,
	mission: 0,
	setMission: (_value: number) => {
	},
	
	answers: {},
	setAnswers: (_value: AnswerMap) => {
	},
	
	phone: '',
	setPhone: (_value: string) => {
	},
	
	day: 0,
	setDay: (_value: number) => {
	}
});

const useCompetitionMuharramContext = () => useContext(CompetitionMuharramContext);

export {
	CompetitionMuharramContext,
	useCompetitionMuharramContext
};
